<agr-summary-card [title]="'TGA.WeatherForecast.Title' | translate">
  @if (loading()) {
    <div class="loading">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  } @else if (error()) {
    <div class="error">
      <p>{{ 'TGA.WeatherForecast.Error' | translate }}</p>
    </div>
  } @else if (weatherData(); as data) {
    <div class="weather-container">
      <p class="subtitle" [innerHTML]="subtitle()"></p>

      <table class="weather-table">
        <thead>
          <tr>
            <th>{{ 'TGA.WeatherForecast.Table.Day' | translate }}</th>
            <th>{{ 'TGA.WeatherForecast.Table.Weather' | translate }}</th>
            <th>{{ 'TGA.WeatherForecast.Table.MinMax' | translate }}</th>
            <th>{{ 'TGA.WeatherForecast.Table.Precipitation' | translate }}</th>
            <th>{{ 'TGA.WeatherForecast.Table.Wind' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (day of weatherDays(); track $index) {
            <tr>
              <td class="day-cell">
                <div class="day-name">{{ capitalizeDayName(day.dayName) }}</div>
                <div class="day-date">{{ day.date | date: 'd' : undefined : locale() }} {{ day.monthName }}</div>
              </td>
              <td class="weather-cell">
                <img [src]="day.iconPath" [alt]="day.conditions" [matTooltip]="day.conditions" class="weather-icon" />
              </td>
              <td class="temp-cell">
                {{ day.temperatureMin | number: '1.0-0' }}°C / {{ day.temperatureMax | number: '1.0-0' }}°C
              </td>
              <td class="precip-cell">{{ day.precipitationMm }} mm</td>
              <td class="wind-cell">
                <div class="wind-info">
                  <img
                    [src]="day.windSvg"
                    [alt]="day.windDirectionCardinal"
                    [matTooltip]="day.windName"
                    class="wind-icon"
                  />
                  <span class="wind-name">{{ day.windName }}</span>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</agr-summary-card>
